import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Label,
  Row,
  Col,
} from "reactstrap";
import { Formik, Form, Field } from "formik";
import { FormattedMessage } from "react-intl";
import TeacherPermissionFields from "../Teacher/TeacherPermissionFields";
import { checkNameLengthAndCharacters } from "../../Utilities/checkerFunctions";

export default function AddNewTeacherToClass(props) {
  function validateEmail(value) {
    let error;
    if (!value) {
      error = <FormattedMessage id="EmailRequired" />;
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
      error = <FormattedMessage id="WrongEmailFormat" />;
    }
    return error;
  }

  function validateName(value) {
    if (!value) {
      return <FormattedMessage id="NameRequired" />;
    }
    const nameCheck = checkNameLengthAndCharacters(value);
    return nameCheck === true ? undefined : nameCheck;
  }

  return (
    <Modal size="md" isOpen={props.isOpen} toggle={props.toggle}>
      <ModalHeader toggle={props.toggle}>
        {props.schoolClass ? (
          <FormattedMessage
            id="CreateNewTeacherForNamedClass"
            values={{ className: props.schoolClass.name }}
          />
        ) : (
          <FormattedMessage id="CreateNewTeacherForClass" />
        )}
      </ModalHeader>
      <Formik
        initialValues={{
          name: "",
          email: "",
          purchaser: false,
          fullAccess: false,
        }}
        onSubmit={(values) => props.onSubmit(values)}
      >
        {({ errors, touched, values, setFieldValue }) => (
          <>
            <Form>
              <ModalBody>
                <Row>
                  <Col lg={12}>
                    <Label className="mt-2" for="name">
                      <FormattedMessage id="Name" />:{" "}
                    </Label>
                  </Col>
                  <Col>
                    <Field
                      name="name"
                      validate={validateName}
                      className="form-control"
                    />
                    {errors.name && touched.name ? (
                      <div className="text-danger input-feedback">
                        {errors.name}
                      </div>
                    ) : null}
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <Label className="mt-2" for="email">
                      <FormattedMessage id="Email" />:{" "}
                    </Label>
                  </Col>
                  <Col>
                    <Field
                      name="email"
                      type="email"
                      validate={validateEmail}
                      className="form-control"
                    />
                    {errors.email && touched.email ? (
                      <div className="text-danger input-feedback">
                        {errors.email}
                      </div>
                    ) : null}
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <TeacherPermissionFields
                      values={values}
                      grantor={{
                        fullAccess: props.fullAccessTeacher,
                        purchaser: props.purchaserTeacher,
                      }}
                      onToggle={setFieldValue}
                    />
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter className="pt-1" style={{ display: "block" }}>
                <Button
                  size="sm"
                  outline
                  color="primary"
                  className="float-end mb-2"
                  type="submit"
                >
                  <FormattedMessage id="AddTeacher" />
                </Button>
                <Button
                  size="sm"
                  outline
                  color="secondary"
                  onClick={props.toggle}
                  className="float-end"
                >
                  <FormattedMessage id="Cancel" />
                </Button>
              </ModalFooter>
            </Form>
          </>
        )}
      </Formik>
    </Modal>
  );
}
